import styled from "styled-components";

import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { PageBreak } from "app/components/layout/PageBreak";
import { IndustryAds } from "app/pages/digital-marketing/ad-intelligence/common/ads/IndustryAds";
import { IndustryAdPlacement } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/breakdowns/IndustryAdPlacement";
import { IndustryDeviceBreakdown } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/breakdowns/IndustryDeviceBreakdown";
import { IndustryFormatBreakdown } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/breakdowns/IndustryFormatBreakdown";
import { IndustryPerformanceOverTime } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/performance-over-time/IndustryPerformanceOverTime";
import { IndustrySpendRank } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/spend-rank/IndustrySpendRank";
import { IndustryTopCampaigns } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/top-campaigns/IndustryTopCampaigns";
import { IndustryTopDomains } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/top-domains/IndustryTopDomains";
import { IndustryTopPublishers } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/top-publishers/IndustryTopPublishers";
import { IndustryTrackedActivity } from "app/pages/digital-marketing/ad-intelligence/common/overview/industry/tracked-activity/IndustryTrackedActivity";
import { MEDIUM_SCREEN_BREAKPOINT } from "app/pages/digital-marketing/ad-intelligence/common/overview/StyledComponents";

const ThreeColumnContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media (max-width: ${MEDIUM_SCREEN_BREAKPOINT}) {
        grid-template-columns: repeat(2, 1fr);
        row-gap: 0;
    }
`;

const IndustryOverviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media print {
        display: block;

        & > * {
            margin-bottom: 24px;
        }
    }
`;

interface IIndustryOverviewProps {
    category: IFlattenedCategory;
}

export const IndustryOverview = ({ category }: IIndustryOverviewProps) => (
    <IndustryOverviewContainer data-automation="industry-overview-container">
        <IndustryTrackedActivity category={category} />
        <IndustryPerformanceOverTime category={category} />
        <PageBreak applyPageBreak />
        <IndustryTopDomains category={category} />
        <ThreeColumnContainer>
            <IndustryDeviceBreakdown category={category} />
            <IndustryFormatBreakdown category={category} />
            <IndustryAdPlacement category={category} />
        </ThreeColumnContainer>
        <PageBreak applyPageBreak />
        <IndustrySpendRank category={category} />
        <IndustryTopCampaigns category={category} />
        <PageBreak applyPageBreak />
        <IndustryAds
            category={category}
            isOverviewContext
        />
        <PageBreak applyPageBreak />
        <IndustryTopPublishers category={category} />
    </IndustryOverviewContainer>
);
